import React from 'react'

const EmployeeTasks = () => {
  return (
    <div>EmployeeTasks</div>
  )
}

export default EmployeeTasks